module.exports = __webpack_public_path__ + "static/media/alarm-blue.927fbf5a.svg";